<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-brand center>Freight Consolidation Executions Details</b-navbar-brand>
          <Filter-Agency-Modal />
          <FilterCBModal />
          <ClientCard />
           <ShipmentTrackCard />
        </b-navbar>

        <b-row>
          <b-col md="2">
            <b-button :variant="Filter.activeButtonFilter ? 'outline-danger' : 'outline-primary'"
              :class="'ml-4' + visible ? null : 'collapsed'" :aria-expanded="Filtervisible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="
                Filtervisible = !Filtervisible;
              clearBranchBtnFilter();
              ">{{ Filtervisible ? "Filter ON" : "Filter OFF" }}</b-button>
          </b-col>
          <b-col md="5" v-if="Filtervisible" class="d-flex flex-wrap">
            <b-button class="mr-1 mb-1" :pressed="activeButtonBranch" v-model="Filter.activeButtonFilter"
              :variant="activeButtonBranch ? 'success' : 'danger'" @click="BranchBtnFilter('Branch')">Branch {{
                activeButtonBranch ? " Filter On" : " Filter Off" }}</b-button>
            <b-button class="mr-1 mb-1" :pressed="activeButtonClient" v-model="Filter.activeButtonFilter"
              :variant="activeButtonClient ? 'success' : 'danger'" @click="BranchBtnFilter('Client')">Client {{
                activeButtonClient ? " Filter On" : " Filter Off" }}</b-button>

            <div v-if="Filter.activeButtonFilter">
              <model-list-select @input="viewFFExportFCL('0', '0', '1', '1')" :list="BranchInvStatusList"
                v-model="Filter.activeTallyBLFilter" option-value="inv" option-text="int"
                placeholder="Select Inv/BL Status"></model-list-select>
            </div>
          </b-col>
          <b-col md="5" class="ml-auto">
            <b-navbar-nav class="ml-auto pull-right mr-1">
              <b-nav-form>
                <b-button @click="goToMain" size="sm" variant="warning">New Assignment</b-button>
                <b-button @click="addPrerequisite" size="sm" variant="warning">New Prerequisite</b-button>
                <b-button @click="goRolloverCont" size="sm" variant="success"
                  style="font-size: 0.675rem ;margin-left: 5px;margin-bottom:4px;">Rollover Container</b-button>
              </b-nav-form>
            </b-navbar-nav>

            <b-button class="pull-right mb-1 mr-1" v-if="FFExport.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('FF_CON_SEA_EXPORT', 'Export As Excel')" size="sm" variant="warning">{{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

            <b-button class="pull-right mb-1 mr-1" @click="gotoPendency()" size="sm" variant="primary">
              Show Pendency List
            </b-button>
          </b-col>
        </b-row>
        <div>
          <div class="row align-items-end">
            <div class="col-md-6">
              <b-form-group style="margin-bottom: 0 !important">
                <b-input-group>
                  <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                    placeholder="Type To Search  (Assignment No. / Client / Container No./SB No. Shipper Inv No.)" />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="col-md-2">
              <label>Months/Year</label>
              <model-list-select @input="viewFFExportFCL('Normal', '0', '0', '1', '1')" :list="dateStatusList"
                v-model="dateStatusFilter" option-value="inv" option-text="int"
                placeholder="Select Date Filter"></model-list-select>
            </div>
            <div class="col-md-2">
              <label>Sob Status</label>
              <model-list-select @input="viewFFExportFCL('0', '0', '1', '1')" :list="SOBStatusList" v-model="SOBFilter"
                option-value="inv" option-text="int" placeholder="Select SOB Status"></model-list-select>
            </div>
            <div class="col-md-2">
              <label>Prealert Status</label>
              <model-list-select @input="viewFFExportFCL('0', '0', '1', '1')" :list="PrealertStatusList"
                v-model="PrealertFilter" option-value="inv" option-text="int"
                placeholder="Select Prealert Status"></model-list-select>
            </div>
          </div>
          <div>
            <h5 class="text-muted pull-right">
              <small>{{ totalRows }} Entries</small>
            </h5>
          </div>
        </div>
        <div class="table-responsive tableMain">
          <!-- Main table element -->
          <b-table show-empty stacked="md" :items="FFExport" :fields="fields" :current-page="currentPage"
            :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection" @filtered="onFiltered">
            <template slot="ffFclConsoExportId" slot-scope="row0">
              <span v-if="row0.item.rollover_event_code == 1" :class="{
                alert: true,
                'alert-danger-text': row0.item.rollover_event_code == 1,
                blink: row0.item.rollover_event_code == 1,
              }"><br />This Event is Rollover</span>
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="ffExportFclConsoSeries" slot-scope="row01">

              <div @click="
                row01.item.is_locked == '1' &&
                  (row01.item.finalBillingCompleted == 1 ||
                    row01.item.locked_counter > 0) &&
                  $sessionsStorage.get('designation') != 'Admin' &&
                  $sessionsStorage.get('nameUser') != 'Bhavneesh'
                  ? ''
                  : viewExportFCLConPage(row01.item.ffFclConsoExportId)
                " class="showMoreData">

                <span>
                  Assignment No.: {{ row01.item.ffExportFclConsoSeries }}
                  <br />
                </span>
                <span>
                  Raised From: {{ row01.item.EmpLoc }}
                  <br />
                </span>

                <span>
                  Date : {{ row01.item.loginTime | moment }}
                  <br />
                </span>
                <b-button style="font-size: 0.675rem" class="mt-2" size="sm" @click="
                  row01.item.is_locked == '1' &&
                    (row01.item.finalBillingCompleted == 1 ||
                      row01.item.locked_counter > 0)
                    ? LockUnLock(row01.item, 'locked')
                    : ''
                  " :variant="row01.item.is_locked == '1' &&
                      (row01.item.finalBillingCompleted == 1 ||
                        row01.item.locked_counter > 0)
                      ? 'danger'
                      : 'success'
                    "><b v-if="
                    row01.item.is_locked == '1' &&
                    (row01.item.finalBillingCompleted == 1 ||
                      row01.item.locked_counter > 0)
                  "><i class="fa fa-lock mr-1 lg"></i>LOCKED</b><b v-else><i
                      class="fa fa-unlock mr-1 lg"></i>UN-LOCKED</b></b-button><br />
                <b :style="'color:black'">Billing : </b>
                <b-badge variant="success" v-if="(row01.item.finalBillingCompleted == '1')">Billing Completed</b-badge>
                <b-badge v-else-if="row01.item.finalBillingCompleted == '4'" variant="success">Billing Completed - Agent
                  Expense Pending</b-badge>
                <b-badge v-else variant="danger">Billing In-complete</b-badge><br />
                <!-- <span v-if="row01.item.finalBillingCompleted == '1'"
                  ><b :style="'color:black'">Billing : </b>
                  <b-badge variant="success"><b>Completed</b></b-badge
                  ><br
                /></span>
                <span v-if="row01.item.finalBillingCompleted == '0'"
                  ><b :style="'color:black'">Billing : </b>
                  <b-badge variant="danger"><b>Pending</b></b-badge
                  ><br
                /></span> -->
                <span v-if="row01.item.is_prealertSend == '1'"><b :style="'color:black'">Prealert Send : </b>
                  <b-badge variant="success"><b>YES</b></b-badge><br /></span>
                <span v-if="row01.item.is_prealertSend == '0'"><b :style="'color:black'">Prealert Send : </b>
                  <b-badge variant="danger"><b>NO</b></b-badge><br /></span>
                <span v-if="
                  row01.item.sob_date_detected != '' &&
                  row01.item.sob_date_detected != null
                "><b :style="'color:black'">SOB : {{ row01.item.sob_date_detected }}</b>
                  <b-badge variant="danger"><b>SAILED</b></b-badge></span>
              </div>

              <b-button class="mt-2" style="font-size: 0.675rem" size="sm" @click="showDocModal(row01.item)"
                variant="outline-info">Summary & Documents</b-button>
              <Assignment-Summary :title="'Shipment Summary Tracking - '" :fk_all_module_id="row01.item.allModuleId"
                :jb_series="row01.item.ffExportFclConsoSeries" />
              <ContainerSummary v-if="row01.item.allModuleId" :PMC_title="'Container Summary Job No - ' + row01.item.ffExportFclConsoSeries
                " :PMC_JOBID="row01.item.allModuleId" :PMC_JOBNO="row01.item.ffExportFclConsoSeries" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_AgentType="''" :PMC_Client="''" :PMC_Sline="''" />
              <!-- <JobWisePaymentsDetails
                  v-if="row01.item.allModuleId"
                  :allModuleId="Number(row01.item.allModuleId)"
                  :JobNo="row01.item.ffExportFclConsoSeries"
                  /> -->
              <br />
              <InvExpSummary v-if="row01.item.allModuleId"
                  :PMC_title="'Inv Exp Summary Job No - ' + row01.item.ffExportFclConsoSeries"
                  :PMC_JOBID="row01.item.allModuleId" :PMC_JOBNO="row01.item.ffExportFclConsoSeries"
                  :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                  :PMC_Client="''" :PMC_Sline="''" />
              <RejectInvTallyBillSummary v-if="row01.item.allModuleId" :PMC_title="'Invoice Rejection Log Summary Job No - ' +
                row01.item.ffExportFclConsoSeries
                " :PMC_JOBID="row01.item.allModuleId" :PMC_JOBNO="row01.item.ffExportFclConsoSeries" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_Client="''" :PMC_Sline="''" />
              <MSDeleteRequest :item="row01.item" :JobNo="row01.item.ffExportFclConsoSeries"
                :JobID="row01.item.allModuleId" :sessionsStorage="$sessionsStorage" @refreshData="handleRefresh" />
              <b
                v-if="row01.item.deleteRequestBy != '' && row01.item.deleteRequestBy != '0' && row01.item.deleteRequestBy != null">Requested
                By : {{ row01.item.deleteRequestBy }}<br /></b>
              <b
                v-if="row01.item.deleteArrovedBy != '' && row01.item.deleteArrovedBy != '0' && row01.item.deleteArrovedBy != null">Arroved
                By : {{ row01.item.deleteArrovedBy }}<br /></b>
              <WebhookLogSummary v-if="row01.item.allModuleId"
                :showTriggerButton="true"
                :PMC_title="'Webhook Log '"
                :PMC_JOBID="row01.item.allModuleId" :PMC_JOBNO="row01.item.ffExportFclConsoSeries"
                :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                :PMC_Client="''" :PMC_Sline="''" />
              <AssignmentSplitMergeSummary v-if="row01.item.allModuleId"
                :PMC_title="'Assignment Split/Merge/Move Summary'"
                :PMC_JOBID="row01.item.allModuleId" :PMC_JOBNO="row01.item.ffExportFclConsoSeries"
                :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                :PMC_Client="''" :PMC_Sline="''" />
              <br />
              <span :style="row01.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''"
                @click="row01.item.SubscriptionId ? goToSubscriptionPage(row01.item) : ''">
                Booking No: {{ row01.item.bookingNumber }}
                <br />
              </span>
            </template>
            <template slot="clientName" slot-scope="row2">
              <div v-if="
                row2.item &&
                row2.item.NotificationAlert2 &&
                row2.item.NotificationAlert2.length > 0
              ">
                <div v-for="(item, index2) in row2.item.NotificationAlert2" :key="index2" class="status-alerts">
                  <span :class="{
                    alert: true,
                    'alert-danger-text': item.type == 2,
                    blink: item.type == 2,
                  }">
                    <strong>{{ item.title }}</strong>
                    <template v-if="item.message">
                      - <strong>{{ item.message }}<br />{{ item.conclusion }}</strong>
                    </template>
                  </span>
                  <br />
                </div>
              </div>
              <div v-else></div>
              <span>{{ row2.item.clientName }}</span>
            </template>
            <template slot="placeRecp" slot-scope="row11">
              <ContaierWebLogSummary v-if="row11.item.allModuleId && row11.item.containerNo"
                :PMC_title="'Container Event Summary Job No - ' + row11.item.ffExportFclConsoSeries"
                :PMC_JOBID="row11.item.allModuleId" :PMC_JOBNO="row11.item.ffExportFclConsoSeries"
                :PMC_CONTNO="row11.item.containerNo" :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                :PMC_Client="''" :PMC_Sline="''" />
              <BookingTrack :containerArr="row11.item.containerNo" :slineName="row11.item.shippingLine"
                :clientName="row11.item.clientName"
                :modal_title="`Container Movement Booking No: ${row11.item.bookingNumber} Job No - ${row11.item.ffExportFclConsoSeries} Client: ${row11.item.clientName}`"
                :JOBNO="row11.item.ffExportFclConsoSeries" :shipment_id="Number(0)" :subscription_id="Number(0)"
                :fk_sub_track_id="Number(0)" :fk_all_module_id="Number(row11.item.allModuleId)"
                :fk_booking_id="Number(row11.item.fk_booking_id)" :fk_container_id="Number(0)"
                :booking_number="row11.item.bookingNumber" :container_number="''" />
              <div>
                <span>
                  Shipping Line : {{ row11.item.shippingLine }}
                  <br />
                </span>
                <span>
                  POR : {{ row11.item.placeRecp }}
                  <br />
                </span>

                <span>
                  Load Port : {{ row11.item.LoadPort }}
                  <br />
                </span>
                <span>
                  POD : {{ row11.item.placeDis }}
                  <br />
                </span>
                <span>
                  FPOD : {{ row11.item.finalPlace }}
                  <br />
                </span>
              </div>
            </template>
            <template slot="eta_details" slot-scope="row321">
              <span v-if="row321.item.ETA_destination_estimated != ''">Tentative : {{
                row321.item.ETA_destination_estimated }}</span>
              <span v-if="row321.item.ETA_destination_actual != ''"><br />Actual : {{ row321.item.ETA_destination_actual
                }}</span>
            </template>
            <template slot="subs_conclusion" slot-scope="row322">
              <span v-if="
                row322.item.sub_noti_event_message != '' && row322.item.sub_noti_event_message != null
              "><b :style="'color:black'">Event MSG : {{ row322.item.sub_noti_event_message }}</b><br /></span>
              <span v-if="
                row322.item.sub_noti_risk != '' && row322.item.sub_noti_risk != null
              "><b :style="'color:black'">Status : {{ row322.item.sub_noti_risk_verbose }}</b><br /></span>
              <span v-if="
                row322.item.sub_noti_risk != '' && row322.item.sub_noti_risk != null
              "><b :style="'color:black'">Desc : {{ row322.item.sub_noti_risk_description }}</b><br /></span>
              <span v-if="
                row322.item.sub_noti_risk != '' && row322.item.sub_noti_risk != null
              "><b :style="'color:black'">Conclusion : {{ row322.item.sub_noti_conclusion }}</b></span>
              <Add-Message :fk_all_module_id="row322.item.allModuleId" :fk_client_id="row322.item.clientId"
                :fk_pod_id="row322.item.PODLocationId" style="list-style-type: none" />
              <!-- row4.item.is_locked == '1' &&
                  row4.item.is_prealertSend == '0' && -->
              <!-- (row322.item.finalBillingCompleted == 1 || -->
              <!-- row322.item.locked_counter > 0) && -->
              <!-- {{row322.item}} -->
              <b-button v-if="
                row322.item.is_locked == '1' &&
                row322.item.is_prealertSend == '1' &&
                (row322.item.CountmainManifestationData <= 0 ||
                  row322.item.manifestcount <= 0)
              " @click="sendMANIFESTATION(row322.item)" size="sm" variant="warning" style="font-size: 0.675rem">SEND
                MANIFESTATION</b-button>
            </template>
          </b-table>
        </div>
        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination limit="5" align="center" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <div>
      <b-modal size="xl" id="doc" class="modal-dialog-doc" no-close-on-esc no-close-on-backdrop ref="doc-modal"
        hide-footer :title="'Assignment Summary & Documents ' + JOBSERIES">
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close
        </b-button>
      </b-modal>

      <!-- Added By Priyanshu Singh For Billing Close Section Start -->
      <b-modal id="modal-lock-conf" ref="modal-lock-conf" title="Reason for Open Locked Assignment" centered
        no-close-on-esc no-close-on-backdrop hide-footer>
        <h3>Confirmation</h3>
        <form ref="form">
          <b-form-group label="Remark" label-for="name-input" invalid-feedback="Name is required">
            <b-form-textarea :formatter="capitalizeAll" rows="5" id="name-input" v-model="lockReason"
              required></b-form-textarea>
          </b-form-group>
        </form>
        <b-button @click="closeLockUnLockConfirm" variant="danger"> Cancel</b-button>
        <b-button v-if="lockReason" :disabled="lock_button ? true : false" variant="success" class="pull-right"
          @click="ConfLock">Send</b-button>
      </b-modal>
      <!-- Added By Priyanshu Singh For Billing Close Section End -->
    </div>
    <!-- <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseSubmit"
      ref="addPopSubmit"
    ></md-dialog-confirm> -->
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import CommonService from "../../services/CommonService.js";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import WebhookLogSummary from "../common/WebhookLogSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import MSDeleteRequest from "../common/MSDeleteRequest.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Sea Freight")) {
      // if (
      //   this.$sessionsStorage.get("designation") == "Admin" &&
      //   this.$sessionsStorage.get("nameUser") == "Bhavneesh"
      // ) {
      this.checkUserLoginTime();
      // }
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewFFConsoExport");
      // this.viewFFExportFCL();
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      Filtervisible: false,
      activeButtonBranch: false,
      activeButtonClient: false,
      Filter: {
        activeButtonFilter: "",
        activeTallyBLFilter: "PendingInvoice",
      },
      ExcelBtnName: "Export As Excel",
      BranchInvStatusList: [
        {
          inv: "PendingInvoice",
          int: "Invoice",
        },
        {
          inv: "PendingBL",
          int: "BL",
        },
      ],

      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      lock_button: false,
      is_locked: "",
      locked_counter: "",

      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      fields: [
        {
          key: "ffFclConsoExportId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ffExportFclConsoSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "eta_details",
          mainkey: "eta_details",
          label: "ETA Destination Details",
          class: "text-left",
        },
        {
          key: "subs_conclusion",
          mainkey: "subs_conclusion",
          label: "Notification Risk Details",
          class: "text-left",
        },
        {
          key: "placeRecp",
          label: "Other Details",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      SOBFilter: "3",
      PrealertFilter: "3",
      // SOBStatusList: [
      //   {
      //     inv: "1",
      //     int: "Sailed",
      //   },
      //   {
      //     inv: "2",
      //     int: "Not Sailed",
      //   },
      //   {
      //     inv: "3",
      //     int: "All",
      //   },
      // ],
      PrealertStatusList: [
        {
          inv: "1",
          int: "Yes",
        },
        {
          inv: "2",
          int: "No",
        },

        {
          inv: "3",
          int: "All",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 1000000000000000,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      filtrActive: 0,
      routePageId: "",
      modalInfo: { title: "", content: "" },
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      FFExport: [],

      dateStatusFilter: "125",
      dateStatusList: [
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],
    };
  },

  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },

  components: {
    // Loading,
    CustomLoader,
    DocForm,
    ModelListSelect,
    AddMessage,
    AssignmentSummary,
    FilterAgencyModal,
    FilterCBModal,
    ContainerSummary,
    InvExpSummary,
    JobWisePaymentsDetails,
    ContaierWebLogSummary,
    WebhookLogSummary,
    AssignmentSplitMergeSummary,
    BookingTrack,
    RejectInvTallyBillSummary,
    ClientCard,
    ShipmentTrackCard,
    MSDeleteRequest,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    checkUserLoginTime() {
      // Fetch the user's login time from your database or wherever you store it
      const userLoginTime = new Date(this.$sessionsStorage.get("con_job_pendency"));
      const currentTime = new Date();
      const compareTime = 3 * 60 * 60 * 1000;

      // Calculate the time difference in milliseconds
      const timeDifference = currentTime - userLoginTime;

      if (timeDifference > compareTime) {
        // Redirect the user to another page using Vue Router
        this.$router.push("/conassignmentPendency");
      }
    },
    sendMANIFESTATION(item) {
      console.log("item=>", item);

      let payload = {
        itemCode: "checkFCLConBlDetails",
        ffFclConsoExportId: item.ffFclConsoExportId,
      };
      CommonService.getAllBLDash(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.FLAG == true) {
              this.$sessionsStorage.set("sendManifest_ffFclConsoallModuleId", "");
              this.$sessionsStorage.set("sendManifest_ffType", "");
              this.$sessionsStorage.set("sendManifest_ffType", "FF Con Export");
              this.$sessionsStorage.set("JOBSERIES", "");
              this.$sessionsStorage.set(
                "sendManifest_ffFclConsoallModuleId",
                item.allModuleId
              );
              this.$sessionsStorage.set(
                "sendManifest_ffFclConsoExportId",
                item.ffFclConsoExportId
              );
              this.$sessionsStorage.set("JOBSERIES", item.ffExportFclConsoSeries);
              this.$router.push({
                path: "/ffExportCon/ffconsendManifestation",
              });
            } else {
              this.alert.content = data.MSG1;
              this.$refs["addPop"].open();
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "frght_fclconsolidationexport",
          update_key: "ffFclConsoExportId",
          Title: tit,
          module_type: "FCL Consolidation Export",
        };
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.lock_button = false;
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
            (this.lockReason = ""), this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => { });
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.allModuleId;
      this.lock_ffExportFclId = items.ffFclConsoExportId;
      this.lock_ffExportFclSeries = items.ffExportFclConsoSeries;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$sessionsStorage.set("editffFclConsoExportId", "");
      this.$router.push({
        path: "/ffExportCon/ffExportFclConsolidation",
      });
    },
    goRolloverCont() {
      this.$router.push({
        path: "/ctt/rollover-event",
      });
    },
    addPrerequisite() {
      this.$sessionsStorage.set("editffFclConsoPreqId", "");
      this.$router.push({
        path: "/ffExportCon/ffExportFclConPreq",
      });
    },

    gotoPendency() {
      this.$router.push({
        path: "/conassignmentPendency",
      });
    },

    JqueryFun() {
      return $(function () {
        return $("#po").DataTable();
      });
    },

    showDocModal(item) {
      console.log(item);
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.ffExportFclConsoSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    changePage() {
      if (this.changePageFilter == "0") {
        this.$router.push({
          path: "/ffExportCon/ffExportFclConsolidation",
        });
      } else {
        this.$router.push({
          path: "/ffExportCon/ffExportFclConsolidation",
        });
      }
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewFFExportFCL("0", "0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL("0", CURRENT, "2", event);
    },
    filterClear() {
      this.filter = "";
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL("0", CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    goToSubscriptionPage(item) {
      if (item.SubscriptionId) {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.SubscriptionId,
        });
      }
    },
    viewExportFCLConPage(FCLCONID) {
      this.$sessionsStorage.set("editffFclConsoExportId", FCLCONID);
      this.$router.push({
        path: "/ffExportCon/ffExportFclConsolidation",
      });
    },
    clearBranchBtnFilter() {
      this.Filter.activeButtonFilter = "";
      this.activeButtonBranch = false;
      this.activeButtonClient = false;
      if (this.Filter.activeButtonFilter) {
        this.viewFFExportFCL("0", "0", "1", "1");
      }
    },
    BranchBtnFilter(type) {
      this.Filter.activeButtonFilter = type;
      if (type == "Branch") {
        this.activeButtonBranch = true;
        this.activeButtonClient = false;
      } else if (type == "Client") {
        this.activeButtonBranch = false;
        this.activeButtonClient = true;
      }
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    getReports(id, btnName) {
      if (id) {
        this.ExcelBtnName = "Downloading Please Wait .....";
        let payload = {
          excelId: id,
          view: "view",
          searchVal: this.filter,
          billingFilter: this.billingFilter,
          SOBFilter: this.SOBFilter,
          PrealertFilter: this.PrealertFilter,
          newContainerFlow: "0",
          dateStatusFilter: this.dateStatusFilter,
          optTypeTransport: this.$sessionsStorage.get("optTypeTransport")
            ? this.$sessionsStorage.get("optTypeTransport")
            : "",
          optAllModuleIdTransport: this.$sessionsStorage.get("optAllModuleIdTransport")
            ? this.$sessionsStorage
              .get("optAllModuleIdTransport")
              .replace(/^,/, "")
              .replace(/,$/, "")
            : "",
          Filter: this.Filter,
        };
        CommonService.getAllPendingReverseTallyList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.excelName) {
                if (id == "FF_CON_SEA_EXPORT") {
                  this.ExcelBtnName = btnName;
                  window.location.href =
                    `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on All_BL_List Error: ", error);
          });
      }
    },
    handleRefresh() {
      this.viewFFExportFCL("Normal", "0", "0", "1", "1");
    },
    viewFFExportFCL(filterIdD, CURRENT, SEARCH, pageNumber) {
      this.isLoading = true;
      this.filtrActive = filterIdD;
      this.routePageId = filterIdD;
      let payload = {
        view: "view",
        searchVal: this.filter,
        SOBFilter: this.SOBFilter,
        PrealertFilter: this.PrealertFilter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        Filter: this.Filter,
        dateStatusFilter: this.dateStatusFilter,
      };
      this.FFExport = [];
      console.log("payload=>", payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/ViewConsoExportListView.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("priyanshu Singh=>", data);
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            this.FFExport = [];
            if (data.ffExportDetails.length > 0) {
              this.FFExport = data.ffExportDetails;
              this.totalRows = data.ffExportDetails.length;
            }
            // alert(this.totalRows);
            console.log("Priyanshu data=>", this.FFExport);
            this.isLoading = false;
            this.$forceUpdate();
            this.JqueryFun();
          }
        })
        .catch((error) => { });
    },
  },
};
</script>
<style>
.status-alerts {
  font-size: 11px;
  /* display: flex; */
  flex-direction: column;
  /* margin-bottom: 20px; */
}

.alert {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  color: #fff;
}

.alert-danger-text {
  /* background-color: #d9534f; Bootstrap danger color */
  color: #d9534f;
  /* Bootstrap danger color */
}

.alert-info-text {
  color: #2a6fde;
  /* background-color: #2a6fde; Bootstrap danger color */
}

.alert-warning {
  background-color: #f0ad4e;
  /* Bootstrap warning color */
}

.alert strong {
  margin-right: 5px;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1s infinite;
  /* Adjust the duration as needed */
}
</style>



// WEBPACK FOOTER //
// viewFFConsoExport.vue?57c042f4